import { render, staticRenderFns } from "./attr-recognition.vue?vue&type=template&id=db5edcba&scoped=true&"
import script from "./attr-recognition.vue?vue&type=script&lang=ts&"
export * from "./attr-recognition.vue?vue&type=script&lang=ts&"
import style0 from "./attr-recognition.vue?vue&type=style&index=0&id=db5edcba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5edcba",
  null
  
)

export default component.exports